const allowedKeys = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Control',
  'Meta',
  'Alt',
  'Shift',
] as const;

const isAllowedKey = (key: string): key is (typeof allowedKeys)[number] =>
  allowedKeys.includes(key as (typeof allowedKeys)[number]);

export const onKeyDownChecker = (
  e: React.KeyboardEvent<HTMLDivElement>,
  maxLength: number,
) => {
  const { key } = e;
  const isAllowed = isAllowedKey(key);
  const isLengthExceeded =
    (e.currentTarget.textContent?.length || 0) >= maxLength;

  if (!isAllowed && isLengthExceeded) {
    e.preventDefault();
  }
};

export const onPasteChecker = (
  e: React.ClipboardEvent<HTMLDivElement>,
  maxLength: number,
) => {
  const pastedText = e.clipboardData.getData('text');
  const actualLength = e.currentTarget.textContent?.length || 0;
  const isLengthExceeded = actualLength + pastedText.length > maxLength;

  if (isLengthExceeded) {
    e.preventDefault();
  }
};
